const PRINT = {
  messages: {
    title: '地図を印刷',
    description: '印刷方法を選択してください',
    normalTitle: '通常印刷',
    normalDesc: '今の画面をそのまま',
    superTitle: '超印刷',
    superDesc: '範囲やサイズを自由に',
    cancel: 'キャンセル',
    hint: '💡 Cmd+P (Ctrl+P) でも印刷できます',

    memoPlaceholder: '印刷用のメモを入力してください',
    memoPreview: 'メモを入力すると、ここにプレビューが表示されます',
    paperLabel: '用紙',
    zoomOut: '広域',
    zoomIn: '詳細',
    print: '印刷',
    close: '閉じる',
    popupBlocked: 'ポップアップがブロックされました。印刷するにはポップアップを許可してください。',
    printTitle: '地図印刷',
    logoAlt: 'マピオン',
    qrAlt: 'QRコード',
  },
  printPaperTypes: {
    a4Portrait: 'a4-portrait',
    a4Landscape: 'a4-landscape',
    a3Portrait: 'a3-portrait',
    a3Landscape: 'a3-landscape',
  },
  sizes: {
    modalMaxWidth: '90vw',
    buttonPadding: '16px 20px',
    paperSizes: {
      'a4-portrait': '600x800',
      'a4-landscape': '800x600',
      'a3-portrait': '800x1200',
      'a3-landscape': '1200x800',
    },
    defaultImageSize: '800x600',
    qrSize: '80x80',
    printWindow: 'width=800,height=650,left=200,top=100',
    mapWidth: 800,
    mapHeight: 600,
    logoHeight: 24,
  },
  printHeight: {
    'a4-portrait': 450,
    'a4-landscape': 420,
    'a3-portrait': 900,
    'a3-landscape': 700,
  },

  zoom: {
    max: 18,
    min: 8,
    step: 1,
  },
  delays: {
    resize: 100,
    print: 500,
  },
  styles: {
    bodyMargin: '0',
    bodyPadding: '15mm',
    fontFamily: 'Arial, sans-serif',
    mapMarginBottom: '8mm',
    memoMarginBottom: '8mm',
    memoFontSize: '12px',
    logoMargin: '5mm 0',
    qrMargin: '5mm 0',
  },
  urls: {
    maplibreCss: 'https://unpkg.com/maplibre-gl/dist/maplibre-gl.css',
    maplibreJs: 'https://unpkg.com/maplibre-gl/dist/maplibre-gl.js',
    qrApi: 'https://api.qrserver.com/v1/create-qr-code/',
  },
};

export default PRINT;
